// eslint-disable-next-line @typescript-eslint/naming-convention
declare let Box: { ContentExplorer: new () => ContentExplorer };
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { ProjectsAPI } from 'src/app/api/projects.api';
import { UserAccountQuery } from 'src/app/store/userAccount/user-account.query';
import { BoxFilesResponse, BoxItem, ContentExplorer } from 'src/box.d';

@Component({
    selector: 'app-content-explorer',
    templateUrl: './content-explorer.component.html',
    styleUrls: ['./content-explorer.component.scss'],
    standalone: false
})
export class ContentExplorerComponent implements AfterViewInit {
  @Input() public projectId: string;
  @Input() public set token(value: string) {
    if (!value) return;
    this._token = value;
  }
  @Input() public folderId: string;
  @Input() public isFolderOwner: boolean;

  @Output() public itemSelected = new EventEmitter<BoxItem>();
  @Output() public filesLoaded = new EventEmitter<number>();
  @Output() public filesMissPreview = new EventEmitter<
    {
      name: string;
      allowPreview?: boolean;
    }[]
  >();
  private _contentExplorer: ContentExplorer;
  private _token: string;
  private _contentExplorerOpen = false;
  private _numberOfFiles: number;

  public uploadedFiles: {
    name: string;
    allowPreview?: boolean;
  }[] = [];

  public constructor(
    private _projectsAPI: ProjectsAPI,
    private userAccountQuery: UserAccountQuery
  ) {}

  public ngAfterViewInit(): void {
    this._contentExplorer = new Box.ContentExplorer();
    this.setContentExplorer();
  }

  private setContentExplorer(): void {
    if (this._contentExplorerOpen) {
      this._contentExplorer.hide();
    }
    this._contentExplorer.show(this.folderId, this._token, {
      container: '#my-box-content-explorer',
      requestInterceptor: (req) => {
        if (req?.data?.name) {
          this.uploadedFiles.push({
            name: req?.data?.name,
            allowPreview: this.checkForTypePreview(req?.data?.name)
          });

          this.filesMissPreview.emit(this.uploadedFiles);
        }

        if (req?.params?.fields) {
          req.params.fields = (req.params.fields as string).replace(
            'representations',
            ''
          );
        }
        return req;
      },
      responseInterceptor: (response) => {
        if (response.status === 409) {
          response.status = 400;
          return response;
        }

        const data = response.data;

        if (this.isFilesResponse(data as BoxFilesResponse)) {
          (data as BoxFilesResponse).item_collection.entries.forEach(
            (e) => (e.modified_by.name = null)
          );

          this._numberOfFiles = (
            data as BoxFilesResponse
          ).item_collection.total_count;
          this.filesLoaded.emit(this._numberOfFiles);
        }

        return response;
      },
      canShare: false,
      canUpload: true,
      logoUrl: '',
      canCreateNewFolder: false
    });

    this._contentExplorer.addListener('select', (e) => {
      if (e?.length) {
        this.itemSelected.emit(e[0]);
      }
    });

    this._contentExplorer.addListener('preview', (e) => {
      if (e) {
        this.itemSelected.emit(e.file);
        this.log('preview', e.file.name);
      }
    });

    this._contentExplorer.addListener('download', (e) => {
      if (e) {
        e.files.forEach((file) => {
          this.log('download', file.name);
        });
      }
    });

    this._contentExplorer.addListener('delete', (e) => {
      if (e) {
        e.forEach((file) => {
          this.log('delete', file.name);
          const removeindex = this.uploadedFiles.findIndex(
            (x) => x.name === file.name
          );
          this.uploadedFiles.splice(removeindex, 1);
        });

        this.filesMissPreview.emit(this.uploadedFiles);
        this.filesLoaded.emit(--this._numberOfFiles);
      }
    });

    this._contentExplorerOpen = true;
  }

  private isFilesResponse(res: BoxFilesResponse): res is BoxFilesResponse {
    return !!res?.item_collection?.entries;
  }

  private log(event: string, fileName: string): void {
    this._projectsAPI
      .logBoxEvent(this.projectId, {
        event,
        fileName: fileName
      })
      .subscribe();
  }

  private checkForTypePreview(type: string): boolean {
    const types = [
      '.ai',
      '.bmp',
      '.cr2',
      '.crw',
      '.dng',
      '.gif',
      '.eps',
      '.heic',
      '.jpeg',
      '.jpg',
      '.nef',
      '.png',
      '.ps',
      '.psd',
      '.raf',
      '.raw',
      '.svg',
      '.svs',
      '.tga',
      '.tif',
      '.tiff',
      '.indd',
      '.indt',
      '.indml',
      '.inx',
      '.3ds',
      '.box3d',
      '.dae',
      '.dwg',
      '.fbx',
      '.obj',
      '.ply',
      '.stl',
      '.csv',
      '.doc',
      '.docx',
      '.gdoc',
      '.gsheet',
      '.ods',
      '.odt',
      '.pages',
      '.pdf',
      '.txt',
      '.xls',
      '.xlsb',
      '.xlsm',
      '.xlsx',
      '.gslide',
      '.gslides',
      '.key',
      '.odp',
      '.ppt',
      '.pptx',
      '.aac',
      '.aif',
      '.aifc',
      '.aiff',
      '.amr',
      '.au',
      '.flac',
      '.m4a',
      '.mp3',
      '.ogg',
      '.ra',
      '.wav',
      '.wma'
    ];
    return types.some((term) => type.toLowerCase().includes(term));
  }
}
